module.exports = __webpack_public_path__ + "quilt3-level1.3eacef4b.png";